<template>
  <div class="c-a-input c-a-input--autocomplete" :class="{ 'c-a-input--invalid': invalid }">
    <label class="c-a-input__label" :for="`region-input-${id}`">{{ label }} <span v-if="required"> *</span>
      <p v-if="hasError">Vänligen välj kommun</p>
    </label>
    <div class="c-a-input__wrapper c-a-input__wrapper--with-icon-left c-a-input__wrapper--with-button">
      <icon class="c-a-input__icon" :icon="'pin_drop'"></icon>
      <v-select :options="subRegions" @input="setSelected" label="Name" style="width: 100%; height: 3rem"
        :select-on-key-codes="[9, 13]"></v-select>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import {
  FETCH_FILTERS,
  GET_REGIONS
} from "../../../../store/store-models/filters-model";

import AutocompleteItem from "../form/AtomInputAutocompleteItemRegion.vue";
import ButtonAtom from "../AtomButton.vue";
import Icon from "../AtomIcon.vue";
import Vue from "vue";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

export default {
  props: {
    id: Number,
    icon: String,
    label: String,
    dataKey: String,
    invalid: Boolean,
    required: Boolean,
    placeholder: String
  },
  data() {
    return {
      model: null,
      subRegions: [],
      matchedSubRegions: [],
      itemTemplate: AutocompleteItem,
      hasError: false
    };
  },
  components: {
    ButtonAtom,
    Icon,
    vSelect
  },
  computed: {
    ...mapGetters({
      regions: GET_REGIONS
    }),
    filteredSuggestions() {
      return [
        {
          data: this.subRegions.filter(item => {
            return (
              item.Name.toLowerCase().indexOf(
                this.query.toLowerCase()
              ) > -1
            );
          })
        }
      ];
    }
  },
  watch: {
    model: function (val) {
      if (val === null) {
        return;
      }
      const data = {
        questionId: this.id,
        label: this.label,
        answers: this.model ? this.model.Id : "",
        text: true
      };

      if (this.dataKey) {
        data.dataKey = this.dataKey;
      }
    }
  },
  methods: {
    ...mapActions({
      fetchFilters: FETCH_FILTERS
    }),
    setSelected(value) {
      if (value) {
        const data = {
          questionId: this.id,
          label: this.label,
          answers: value ? value.Id : "",
          text: true
        };

        if (this.dataKey) {
          data.dataKey = this.dataKey;
          this.$emit("updateData", data);
          this.hasError = false;
        }
      }
    },
    createSubRegionsArray() {
      const arr = [];
      for (var region in this.regions) {
        for (var subCat in this.regions[region].Subcategories) {
          arr.push(this.regions[region].Subcategories[subCat]);
        }
      }
      arr.sort((a, b) => a.Name.localeCompare(b.Name));

      this.subRegions = arr;
    }
  },
  async created() {
    await this.fetchFilters();
    this.createSubRegionsArray();
  }
};
</script>

<style>
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
  left: 1.7rem;
}

.vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: flex;
  padding: 0 0 4px;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  white-space: normal;
  height: 3rem !important;
  border-radius: 0 !important;
  border: 1px solid #005b83 !important;
}

.vs__clear {
  fill: rgba(60, 60, 60, 0.5);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
  display: none;
}

.vs__actions {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0.5rem;
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  height: 3rem;
  width: 3rem;
  background-color: #005b83;
  color: #fff !important;
  pointer-events: none;
}

.vs__open-indicator {
  fill: white;
  transform: scale(1);
  transition: transform 0.15s cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomInputAutocompleteRegionRequestForm.vue